import Api from './Api';

class LogicBaseNotificationApi extends Api {
  url = 'logicbasenotifications';
}

const singleton = new LogicBaseNotificationApi();
export default singleton;
